/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';

import Icon from '../Icon';
import Like from '../common/Like';
import { IDS } from '../../constants/ids';
import { COLORS } from '../../constants/styles';
import { COMMON } from '../../constants/strings';

import styles from './index.styl';

@injectIntl
@CSSModules(styles, { allowMultiple: true })
export default class Stats extends Component {
  static propTypes = {
    totalComments: PropTypes.number,
    totalLikes: PropTypes.number,
    liked: PropTypes.bool,
    commentAction: PropTypes.func,
    likeAction: PropTypes.func,
    hasActions: PropTypes.bool,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }),
  };

  state = {
    active: this.props.liked,
    likesCount: this.props.totalLikes || 0,
  };

  @autobind
  handleAddLike() {
    const { likeAction } = this.props;
    const { active, likesCount } = this.state;

    this.setState({
      active: !active,
      likesCount: active ? likesCount - 1 : likesCount + 1,
    });

    likeAction();
  }

  render() {
    const { active, likesCount } = this.state;
    const {
      totalComments,
      commentAction,
      liked,
      likeAction,
      totalLikes,
      intl: { formatMessage },
      hasActions,
    } = this.props;

    const fill = COLORS.grayDark;

    return (
      <div styleName="footer__stats">
        <button
          onClick={commentAction}
          id={IDS.POST.COMMENT_ICON}
          styleName="footer__stats__action"
          disabled={!hasActions}
        >
          <Icon name="comment" size={16} style={{ fill }} />
          <span styleName="footer__stats__text">
            {formatMessage(COMMON.comments)} ({totalComments})
          </span>
        </button>
        <button
          styleName="footer__stats__action"
          id={IDS.POST.LIKE_ICON}
          onClick={likeAction}
          disabled={!hasActions}
        >
          <Like active={liked} />
          <span styleName="footer__stats__text">
            {formatMessage(COMMON.likes)} ({totalLikes}){' '}
          </span>
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PostPreview/Stats.jsx